module.exports = __webpack_public_path__ + "img/logo2.7872a802.png";